<style lang="scss" type="text/scss" >
</style>
<template>
<el-dialog
  :title="registerLan.title"
  :visible.sync="dialogVisible"
  width="30%"
  :before-close="handleClose">
        <el-form  ref="ruleForm" :rules="rules" label-width="80px" :model="formLabelAlign">
        <el-form-item :label="sidebarLan1.roleName" prop="Role_No">
            <el-input v-model="formLabelAlign.Role_No"></el-input>
        </el-form-item>
         <el-form-item :label="sidebarLan1.roleDesc" prop="Desc">
                <el-input type="textarea" v-model="formLabelAlign.Desc"></el-input>
         </el-form-item>
          <el-tree
            :data="data2"
            show-checkbox
            default-expand-all
            node-key="Role_ID"
            ref="tree"
            highlight-current
            :props="defaultProps">
          </el-tree>
        <el-button @click="setCheckedNodes" v-if="!selectBool">{{registerLan.selectBtn}}</el-button>
        <el-button @click="setCheckedNodes" v-if="selectBool">{{registerLan.emptyBtn}}</el-button>
        </el-form>
          <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = resetForm('ruleForm')">{{registerLan.logOut.no}}</el-button>
    <el-button type="primary" @click="submitForm('ruleForm')">{{registerLan.logOut.yes}}</el-button>
  </span>
</el-dialog>
</template>
<script>
import sidebarListLink from './../MultiLanguage/menuAllList'
import  {URL_ADDROLE } from '../api/api.js'
import _ from "lodash";
export default {
    mixins: [
    require("common/mixin/base.js").base({registerLan:"authOption"}),
    require("common/mixin/base.js").base({sidebarLan:"sidebarList"}),
    require("common/mixin/base.js").base({sidebarLan1:"tableModelAuthList"}),
    require("common/mixin/base.js").base({addRoleDialogLan:"addRoleDialog"}),
  ],
     data() {
       const validateNo = (rule, value, callback) => {
            if (!value.trim() || value == "") {
                callback(new Error(this.addRoleDialogLan.not_empty));
                return;
            }
            var titleReg = /^[a-zA-Z0-9_-]{4,16}$/;
             if(!titleReg.test(value)){
                callback(new Error(this.addRoleDialogLan.roleNameError));
                return
            }
                callback();
        };
        const validateDesc = (rule, value, callback) => {
            if (!value.trim() || value == "") {
                callback(new Error(this.addRoleDialogLan.not_empty));
                return;
            }
                callback();
        };
      return {
        dialogVisible: false,
        formLabelAlign: {
          Role_No: '',
          Desc: '',
        },
        selectBool:false,
         defaultProps: {
          label: 'label'
        },
        list:[],
         rules: {
          Role_No: [
            { required: true, validator: validateNo, trigger: 'change' },
          ],
          Desc: [
            { required: true, validator: validateDesc, trigger: 'change' },
          ]}
      };
    },
    computed: {
    data2(){
    let data = [];
        // this.data2 = sidebarList;
        for(var key in sidebarListLink){
          sidebarListLink[key].label = this.sidebarLan[key].text;
          sidebarListLink[key].name = key;
          data.push(sidebarListLink[key]);
        }
        return data;
    }
  },
    methods: {
        setCheckedNodes() {
        //全选
        if(!this.selectBool){
            this.$refs.tree.setCheckedNodes(this.data2);
            this.selectBool=true;
        }else{
            this.$refs.tree.setCheckedKeys([]);//清空
            this.selectBool=false;
        }
      },
      setCheckedKeys() {
        this.$refs.tree.setCheckedKeys();
      },
      submit(){

      },
      submitForm(formName) {
        var obj = _.find(this.list,item=>{
            return item.Role_ID == this.formLabelAlign.Role_No
        })
        if(obj){
          return this.$message.error(this.addRoleDialogLan.role_exists);
        }
        var nodes = this.$refs.tree.getCheckedKeys();
        if (nodes.length === 0) return this.$message.error(this.addRoleDialogLan.select_one_option);
        let data = {"role":this.formLabelAlign.Role_No,"Desc":this.formLabelAlign.Desc,"prioritys":nodes}
        this.$refs[formName].validate((valid) => {
          if (valid) {
                this.$http.post(URL_ADDROLE,data).then(res => {
                this.$emit("addRefresh");
                this.$refs[formName].resetFields();
                if(res.data.code == 700){
                  this.$message.error(this.addRoleDialogLan.role_exists)
                }
                this.handleClose();
                })
          } else {
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      handleClose() {
        this.$refs["ruleForm"].resetFields();
        this.dialogVisible = false;
        this.selectBool=false;
        this.$refs.tree.setCheckedKeys([]);//清空
      },
      open(list){
            this.list = list
            this.dialogVisible = true;
      }
    }
}
</script>



// WEBPACK FOOTER //
// add-role-dialog.vue?57b07a0f